import { createContext, useState } from 'react'

export const ProductsContext = createContext({})

export function ProductsProvider({ children }) {
  const [productsToExport, setProductsToExport] = useState([])

  function resetProducts() {
    setProductsToExport([])
  }

  function removeProduct(codProduct) {
    setProductsToExport((prevState) =>
      prevState.filter((prod) => prod.CODPRODUTO !== codProduct),
    )
  }

  return (
    <ProductsContext.Provider
      value={{
        productsToExport,
        setProductsToExport,
        removeProduct,
        resetProducts,
      }}
    >
      {children}
    </ProductsContext.Provider>
  )
}
